(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[802],{

/***/ 6010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 4082:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story",
      function () {
        return __webpack_require__(5875);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Title */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var Title = function(param) {
    var src = param.src, title = param.title, subtitle = param.subtitle, _additionalClassName = param.additionalClassName, additionalClassName = _additionalClassName === void 0 ? "" : _additionalClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center relative ".concat(subtitle ? "h-10" : "h-12", " ") + additionalClassName,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: src,
            alt: title,
            layout: "fill",
            objectFit: "contain"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 5875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorySlugPage": function() { return /* binding */ StorySlugPage; },
/* harmony export */   "StorySlugPageView": function() { return /* binding */ StorySlugPageView; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5934);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8767);
/* harmony import */ var _components_global_CTitle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5479);
/* harmony import */ var _components_layout_Default__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8593);
/* harmony import */ var _utils_createApiClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1277);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    letter-spacing: 1.8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    background-color: #ffffff33;\n    letter-spacing: 0.1em;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StoryHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var StoryImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var StorySlugPageView = function(param) {
    var storyList = param.storyList, story = param.story, onClickStory = param.onClickStory, onClickThumbnail = param.onClickThumbnail, active = param.active, isSelectThumbnail = param.isSelectThumbnail;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_layout_Default__WEBPACK_IMPORTED_MODULE_7__/* .DefaultLayout */ .H, {
        pageTitle: "\u30B9\u30C8\u30FC\u30EA\u30FC",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "md:pb-[6vw] px-4 max-w-[1200px] m-auto flex flex-col justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_global_CTitle__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    src: "/images/title/story.svg",
                    title: "\u30B9\u30C8\u30FC\u30EA\u30FC",
                    additionalClassName: "hidden md:block"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "flex flex-wrap w-full md:mb-14 mb-6 md:mt-16 ",
                    children: (storyList === null || storyList === void 0 ? void 0 : storyList.list.length) && (storyList === null || storyList === void 0 ? void 0 : storyList.list.map(function(it) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)([
                                "flex justify-center md:px-12 px-4 md:py-1 py-0.5 md:mr-4 mr-2 md:mb-4 mb-2 border-4 cursor-pointer text-xl font-black", 
                            ], active, it.uuid === (story === null || story === void 0 ? void 0 : story.uuid) ? [
                                "bg-c-secondary text-c-primary border-c-secondary"
                            ] : [
                                "bg-c-primary text-white border-white bg-opacity-40"
                            ]),
                            onClick: function() {
                                return onClickStory(it.uuid);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "self-center",
                                children: it.episode
                            })
                        }, it.uuid);
                    }))
                }),
                story && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StoryHeader, {
                            className: "md:mb-8 mb-4 md:p-10 p-4 bg-c-secondary",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex justify-start md:text-2xl text-xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-c-primary mr-2 font-bold",
                                        children: story.episode
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "font-semibold text-[#333333]",
                                        children: story.title
                                    })
                                ]
                            }, story.uuid)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StoryImage, {
                            className: "md:p-10 md:mb-8 p-4 mb-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "relative",
                                    children: story.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: story.thumbnail[isSelectThumbnail],
                                        alt: story.title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "grid grid-cols-5 md:gap-4 gap-1 md:mt-4 mt-2",
                                    children: story.thumbnail.map(function(it, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "cursor-pointer",
                                            onClick: function() {
                                                return onClickThumbnail(index);
                                            },
                                            children: story.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: it,
                                                alt: story.title
                                            })
                                        }, story.uuid + index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "md:p-10 p-4 md:font-light font-normal text-c-normal-text bg-white md:text-xl text-sm md:leading-10 leading-7",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: story.description
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var StorySlugPage = function() {
    var apiClient = (0,_utils_createApiClient__WEBPACK_IMPORTED_MODULE_8__/* .createApiClient */ .U)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), findStory1 = ref[0], setStory = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), active = ref1[0], setActive = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), isSelectThumbnail = ref2[0], setThumbnail = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref3 = (0,react_query__WEBPACK_IMPORTED_MODULE_5__.useQuery)([], _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var body;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return apiClient.api.story.get();
                case 2:
                    body = _ctx.sent.body;
                    setStory(body.list[0]);
                    if (!(body.list.length === 0)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return router.push({
                        pathname: "/"
                    });
                case 7:
                    return _ctx.abrupt("return", body);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        keepPreviousData: false
    }), data = ref3.data, isLoading = ref3.isLoading;
    var onClickStory = function(storyId) {
        var selectId = storyId;
        var findStory = data === null || data === void 0 ? void 0 : data.list.find(function(it) {
            return it.uuid === selectId;
        });
        setStory(findStory);
        setActive(!active);
    };
    var onClickThumbnail = function(index) {
        setThumbnail(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StorySlugPageView, {
        storyList: data,
        onClickStory: onClickStory,
        onClickThumbnail: onClickThumbnail,
        isLoading: isLoading,
        story: findStory1,
        active: active,
        isSelectThumbnail: isSelectThumbnail
    });
};
/* harmony default export */ __webpack_exports__["default"] = (StorySlugPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [416,587,774,888,179], function() { return __webpack_exec__(4082); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);